<template>
  <div>
    <b-modal id="successModal" hide-footer v-on:hidden="modalHidden()">
      <template v-slot:modal-title>
        Merci!
      </template>
      <p>La commande a bien été enregistrée. Vous recevrez un email de confirmation d'ici peu.</p>
      <p>A très vite, <br> Les Pirates de la Bouffe</p>
    </b-modal>
  </div>
</template>

<style>
  .modal-body {
    padding: 1rem;
  }
</style>

<script>
  export default {
    name: 'SuccessModal',
    methods: {
      modalHidden() {
        this.$emit('hidden', true);
      },
    },
    mounted() {
      this.$bvModal.show('successModal');
    },
  }
</script>
